import { render, staticRenderFns } from "./file-edit.vue?vue&type=template&id=15b8d2fa&scoped=true&"
import script from "./file-edit.vue?vue&type=script&lang=js&"
export * from "./file-edit.vue?vue&type=script&lang=js&"
import style0 from "./file-edit.vue?vue&type=style&index=0&lang=less&"
import style1 from "./file-edit.vue?vue&type=style&index=1&id=15b8d2fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15b8d2fa",
  null
  
)

export default component.exports